import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";

import { FlexLayoutModule } from "@angular/flex-layout";

import { TranslateModule } from "@ngx-translate/core";
import { AgGridModule } from "@bfx/ag-grid-angular";
import { AutoCompleteModule } from "@bfx/primeng/autocomplete";
import { CheckboxModule } from "@bfx/primeng/checkbox";
import { DialogModule } from "@bfx/primeng/dialog";
import { ButtonModule } from "@bfx/primeng/button";
import { OverlayPanelModule } from "@bfx/primeng/overlaypanel";

import { BfxSharedModule } from "../bfx-shared/bfx-shared.module";
import { BfxBlotterFilterModule } from "../bfx-blotter-filter/bfx-blotter-filter.module";
import { BfxBlotterOrders } from "./bfx-blotter-orders";
import { BfxBlotterOrdersContextMenuService } from "./bfx-blotter-orders-contextmenu.service";
import { BfxBaseBlotterColumnSelectorService } from "../bfx-base-blotter/bfx-base-blotter-columnselector.service";
import { BfxBlotterOrdersService } from "./bfx-blotter-orders.service";
import { BfxVwapModule } from "../bfx-vwap/bfx-vwap.module";
import { BfxBlotterOrdersActionService } from "./bfx-blotter-orders-action.service";
import { BfxOrderBlotterFilteringService } from "./bfx-blotter-orders-filter.service";
import { BfxMenusModule } from "../bfx-menus/bfx-menus.module";

import { OrderTypeRenderer } from "./renderers/OrderTypeRenderer";
import { PercentAwayRenderer } from "./renderers/PercentAwayRenderer";
import { MarketMidRenderer } from "./renderers/MarketMidRenderer";
import { FwdPtsRenderer } from "./renderers/FwdPtsRenderer";
import { FillRenderer } from "./renderers/FillRenderer";

import { SpotTrackingRenderer } from "./renderers/SpotTrackingRenderer";
import { BfxElementsLibraryModule } from "app/bfx-element-library/bfx-elements-library.module";
import { BfxBlotterOrdersActionSubjectModule } from "./bfx-blotter-orders-action-subject.module";
import { BfxBlotterOrdersContextMenu } from "./bfx-blotter-orders-contextmenu";
import { BaseComponentsModule } from "shared/base-components/base-components.module";
import { FillPercentRenderer } from "app/bfx-blotter-orders/renderers/FillPercentRenderer";
import { CommonIntentRenderer } from "app/bfx-blotter-orders/renderers/CommonIntentRenderer";

@NgModule({
  declarations: [
    BfxBlotterOrders,
    OrderTypeRenderer,
    CommonIntentRenderer,
    FillRenderer,
    FillPercentRenderer,
    SpotTrackingRenderer,
    PercentAwayRenderer,
    MarketMidRenderer,
    FwdPtsRenderer,
    BfxBlotterOrdersContextMenu,
  ],
  imports: [
    CommonModule,
    FormsModule,
    TranslateModule,
    FlexLayoutModule,
    AutoCompleteModule,
    CheckboxModule,
    DialogModule,
    ButtonModule,
    OverlayPanelModule,
    AgGridModule.withComponents([
      OrderTypeRenderer,
      CommonIntentRenderer,
      FillRenderer,
      FillPercentRenderer,
      SpotTrackingRenderer,
      PercentAwayRenderer,
      MarketMidRenderer,
      FwdPtsRenderer,
    ]),
    BfxVwapModule,
    BfxSharedModule,
    BfxElementsLibraryModule,
    BfxBlotterFilterModule,
    BfxMenusModule,
    BfxBlotterOrdersActionSubjectModule,
    BaseComponentsModule,
  ],
  exports: [BfxBlotterOrders, CommonIntentRenderer],
  providers: [
    BfxBlotterOrdersContextMenuService,
    BfxBlotterOrdersService,
    BfxOrderBlotterFilteringService,
    BfxBlotterOrdersActionService,
    BfxBaseBlotterColumnSelectorService,
  ],
  bootstrap: [BfxBlotterOrders],
})
export class BfxBlotterOrdersModule {}
